import { render, staticRenderFns } from "./Speciality.vue?vue&type=template&id=396d1874&scoped=true&"
import script from "./Speciality.vue?vue&type=script&lang=js&"
export * from "./Speciality.vue?vue&type=script&lang=js&"
import style0 from "./Speciality.vue?vue&type=style&index=0&id=396d1874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d1874",
  null
  
)

export default component.exports